export interface AnamnesaItem {
  key: string;
  label: string;
}

export interface PemfisField {
  key: string;
  label: string;
  unit?: string;
}

export interface PenunjangField {
  key: string;
  label: string;
}

export interface AsaOption {
  value: string;
  label: string;
}

export const ANAMNESA_ITEMS: AnamnesaItem[] = [
  { key: "hilang_gigi", label: "Hilangnya Gigi" },
  { key: "masalah_mobilisasi_leher", label: "Masalah mobilisasi leher" },
  { key: "leher_pendek", label: "Leher pendek" },
  { key: "batuk", label: "Batuk" },
  { key: "sesak_nafas", label: "Sesak nafas" },
  { key: "nyeri_dada", label: "Nyeri dada" },
  { key: "denyut_jantung_abnormal", label: "Denyut jantung tidak normal" },
  { key: "kejang", label: "Kejang" },
  { key: "merokok", label: "Merokok" },
  { key: "alergi", label: "Alergi" },
  { key: "stroke", label: "Stroke" },
  { key: "pingsan", label: "Pingsan" },
  { key: "muntah", label: "Muntah" },
  { key: "hamil", label: "Sedang Hamil" },
  { key: "menstruasi_abnormal", label: "Menstruasi tidak normal" },
  { key: "susah_kencing", label: "Susah Kencing" },
  { key: "obesitas", label: "Obesitas" },
  { key: "hipertensi", label: "Hipertensi" },
  { key: "gigi_palsu", label: "Gigi Palsu" },
  { key: "dm", label: "DM" }
];

export const PEMFIS_FIELDS: PemfisField[] = [
  { key: "tinggi_badan", label: "Tinggi Badan", unit: "cm" },
  { key: "berat_badan", label: "Berat Badan", unit: "kg" },
  { key: "rr", label: "RR", unit: "x/mnt" },
  { key: "suhu", label: "Suhu", unit: "°C" },
  { key: "nadi", label: "Nadi", unit: "x/mnt" },
  { key: "td_sistole", label: "TD Sistole", unit: "mmHg" },
  { key: "td_diastole", label: "TD Diastole", unit: "mmHg" }
];

export const PENUNJANG_FIELDS: PenunjangField[] = [
  { key: "hb_ht", label: "Hb / Ht" },
  { key: "natrium", label: "Natrium" },
  { key: "clorida", label: "Clorida" },
  { key: "kalium", label: "Kalium" },
  { key: "pt_aptt", label: "PT / APTT" },
  { key: "ureum", label: "Ureum" },
  { key: "creatinin", label: "Creatinin" },
  { key: "hbsag", label: "HbsAg" },
  { key: "rontgen_thorax", label: "Rontgen Thorax" },
  { key: "ekg", label: "EKG" }
];

export const ASA_OPTIONS: AsaOption[] = [
  { value: "I", label: "ASA I" },
  { value: "II", label: "ASA II" },
  { value: "III", label: "ASA III" },
  { value: "IV", label: "ASA IV" },
  { value: "V", label: "ASA V" }
];
